// export const API_REQUEST = "http://3.110.1.210:8082";

export const APP_MESSAGE_BROADCAST_CHANNEL = "RadSpace";


export const modalTypes = {
    ADD: "Add",
    EDIT: "Edit",
};

export const groupModalTypes = {
  ADD: "GROUP_ADD",
  EDIT: "GROUP_EDIT",
};

export const AUTHORIZED_ROLES = ["ADMIN", "GUILDLIBRARIAN", "MRT", "MIS", "TYP", "GROUPADMIN", "RECEPTIONIST"];

export const INTEGRATOR_AUTHORIZED_ROLES = ["MRT", "MIS"];

export const REFRESH_TOKEN_INTERVAL_IN_MILLISECONDS = 13800 * 1000; // 230 minutes

export const DOCSCANNER_SERVICE_WEBSOCKET_URL = "ws://127.0.0.1:8089/";
export const BE_SERVICE_WEBSOCKET_URL = "ws://10.90.0.11:8080/ws";

export const dateFormatList = [
    "DD-MM-YYYY",
    "DD/MM/YYYY",
    "DDMMYYYY",
    "YYYY-MM-DD",
    "YYYY-MM-DD hh:mm ss",
    "YYYY-MM-DD hh:mm a",
    "YYYY-MM-DD HH:mm"
];

export const DATE_FORMATS = {
  "DD-MM-YYYY": "DD-MM-YYYY",
  "DD/MM/YYYY": "DD/MM/YYYY",
  DDMMYYYY: "DDMMYYYY",
  "YYYY-MM-DD": "YYYY-MM-DD",
  "YYYY-MM-DD hh:mm a": "YYYY-MM-DD hh:mm a",
  "YYYY-MM-DD HH:mm": "YYYY-MM-DD HH:mm",
  "DD-MM-YYYY HH:mm:ss": "DD-MM-YYYY HH:mm:ss",
};

export const paginationSize = 100;
export const pageSizeOptions = ['20', '50', '100', '150', '200'];

export const dataTypes = {
    NUMBER: "NUMBER",
    STRING: "STRING",
    DATE: "DATE"
}

export const EVENT_TYPES = {
    SELECTION: "SELECTION",
    APPOINTMENT: "APPOINTMENT",
    ROSTER: "ROSTER",
    RESERVE: "RESERVE"
}

export const URGENCY_LEVELS = {
    "EMERGENCY": "J",
    "URGENT": "A",
    "NORMAL": "R"
}

export const TIMEZONES = [
    "Asia/Kolkata",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Hobart",
    "Australia/Lindeman",
    "Australia/Lord_Howe",
    "Australia/Melbourne",
    "Australia/Perth",
    "Australia/Sydney"
]

export const CALENDER_SLOTS_EVENTS = {
    COPY:"COPY",
    PASTE: "PASTE"
}

export const ACCOUNT_TYPE = {
    MEDICARE:"MEDICARE",
    INSURANCE: "INSURANCE"
}

export const ORGANIZATION_ACTION = {
    CREATE: "Create",
    EDIT: "Edit",
    VIEW: "View"
};

export const PAYMENT_STATUS = {
    UNKNOWN: "UNKNOWN",
    REJECTED: "REJECTED",
    PARTIALLY_PAID: "PARTIALLY PAID",
    PAID: "PAID",
};

export const SMG_SITES = ["SMH","HPH","SMA"];

export const regExp = /^(?!.*[\s])(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[-+`~,<>;:'"\|!@#$%^&*()_./{}])(?!.*[~\`\=[\]\\]).{8,16}/

export const modifiers = [
  { label: "Not for Comparison", value: "NC" },
  { label: "Separate Sites", value: "SP" },
  { label: "Not Related", value: "NR" },
];

export const ONE_DAY_CALENDAR_SITES = ["SMH", "SMA", "HPH", "KMI","RPHMI", "PPR", "MRC"]

export const NON_MEDICARE_CASETYPES = [
  "PRIVATE",
  "INSURANCE",
  "WORKCOVER",
  "NOCHARGE",
  "MVIT",
  "MRINOW",
];

export const MEDICARE_CASETYPES = [
  "BULKBILL",
  "BBINP",
  "FUNDSONLINE",
  "OUTPATIENTCLAIM",
  "INPATIENTCLAIM",
];

export const MEDICARE_CLAIM_REJECTED_STATUS = [
  "Rejected",
  "MEDICARE_REJECTED",
  "HEALTH_FUND_REJECTED",
];

export const MEDICARE_CLAIM_UNPROCESSED_STATUS = [
  ...MEDICARE_CLAIM_REJECTED_STATUS,
  "CANCELLED",
  "PENDING",
];

export const MEDICARE_STATUS_PRIORITY = {
  PROCESSED: 1,
  PARTIALLY_PROCESSED: 1,
};

export const DEFAULT_CASE_TYPE_OPTIONS = [
  { value: "PRIVATE", label: "Private" },
  { value: "BULKBILL", label: "Bulk Bill" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "WORKCOVER", label: "Work Cover" },
  { value: "NOCHARGE", label: "No Charge" },
  { value: "FUNDSONLINE", label: "Funds Online" },
  { value: "BBINP", label: "BBINP" },
  { value: "OUTPATIENTCLAIM", label: "Out Patient Claim" },
  { value: "INPATIENTCLAIM", label: "In Patient Claim" },
  { value: "MVIT", label: "MVIT" },
  { value: "MRINOW", label: "MRINOW" },
  { value: "PENOUT", label: "PENOUT" },
];
